import Axios from 'axios';
import Vue from 'vue';
import Confirm from '../../components/confirmation/confirm.vue';
import moment from 'moment'


export default Vue.extend({
    components: {
        Confirm,
    },

    data: () => ({
      jobs : [],
      all_candidate_id : [],
      single_candidate_id : '',
      dataLoading: false
    }),

    created(){
      this.all_candidate_id = JSON.parse(localStorage.getItem('all_id'));
      console.log("1",this.all_candidate_id);
      this.single_candidate_id = localStorage.getItem('id');
      console.log("2",this.single_candidate_id);
      this.all_job();
    },

    methods:{
      async all_job(){
        this.dataLoading = true;
        let token =  localStorage.getItem("jwt");
        let userId =  localStorage.getItem("userId");
        this.dataLoading = true;
        if (token && userId) { 
          const auth = {
            headers: {authorization: token} 
          }  
          let resp = await this.$http.get('job/fetchJobsByRecruiter/'+userId, auth)
          console.log(resp);
          if (resp.status === 200 && resp.data.message === "Jobs found"){
            console.log(resp);
            this.jobs = resp.data.jobs;
            for (let i = 0; i < this.jobs.length; i++) {
              for (let j = 0; j < this.jobs[i].exam_dates.length; j++) {
                var day = moment.unix(this.jobs[i].exam_dates[j]);
                this.jobs[i].exam_dates[j] = day.format('MMMM Do YYYY, h:mm a')
              }
            }
            console.log(this.jobs);
          }
            this.dataLoading = false;
        }
      },

      backPage() {
        window.history.back()
      },

      async go_to_talent(id){
        localStorage.removeItem("JobId")
       
        // if (token) {
        //   console.log("token",token);
        //   Axios.post('https://yqroi4mbbd.execute-api.us-east-1.amazonaws.com/prod/email-token-receive',{
        //     token,
        //     to : this.single_candidate_email==null?this.all_candidate_email:[this.single_candidate_email],
        //     body: '<div>Dear #FirstName,</div><div><br></div><div>Thank you for your interest in our Company.&nbsp; We would like to get to know you</div>',
        //     sub:'Invite Candidate',
        //     cc:[], 
        //     bcc:[],
        //     job_id : parseInt(id)
        //   }).then(resp =>{
        //     if (!resp.data.error) {
        //       console.log("jhjhggyugyggygy");
        //       this.snackbar = true;
        //       this.showMessage = 'Invited Successfully.'
        //       localStorage.setItem("JobId",id);
        //       this.$router.push("/invite_talent/"+id);
        //     } else {
        //       this.snackbar = true;
        //       this.showMessage = 'Something wrong! Please try again.'
        //     }
        //   })
        // }
        // try{
          // if (await this.$refs.confirm.open('Invite Candidate', 'Are you sure?', {color: 'black'})) {
          
        // }
        try {
           this.$swal({
            title: 'Invite Candidate',
            text: 'Are you sure?',
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Send',
            cancelButtonText:'Cancel',
            customClass: 'swal-title-jobapplication'
        }).then((result) => {
          if (result.isConfirmed) {
            this.sendInvite(id);
          }
         
        })

        }catch(error){
          this.dataLoading = false;
          this.snackbar = true;
          this.showMessage = 'Something wrong! Please try again.'
        }
      },

      async sendInvite(id){

            this.dataLoading = true;
            let token = localStorage.getItem("jwt");
            let userId = localStorage.getItem("userId");
            if (token && userId) {
                const auth = {
                    headers: {authorization: token} 
                }  
                let allresult = [];
                let res : any;
                console.log("dh",this.single_candidate_id); 
                if (this.single_candidate_id!=null) {
                    res = await this.$http.post('/job/inviteStudent',{
                        "student_id": this.single_candidate_id,
                        "recruiter_id": userId,
                        "job_id": id,
                        "email_body": '</div><div><br></div><div>Thank you for your interest in our Company.&nbsp; We would like to get to know you</div>',
                        "email_subject": "Test invitation email"
                    },auth)
                    if (res.status === 200 && res.data.message === 'Invitation sent') {
                        console.log("jhjhggyugyggygy");
                        this.dataLoading = false;
                        this.snackbar = true;
                        this.showMessage = 'Invited Successfully.'
                        this.$router.push({name : 'invite_talent', params: { id: id }});
                    } else {
                        this.dataLoading = false;
                        this.snackbar = true;
                        this.showMessage = 'Something wrong! Please try again.'
                    }
                } else {
                  console.log("enter invite");
                    for (let j = 0; j < this.all_candidate_id.length; j++) {
                        console.log("enter invite");
                        await this.$http.post('/job/inviteStudent',{
                            "student_id": this.all_candidate_id[j],
                            "recruiter_id": userId,
                            "job_id": id,
                            "email_body": '</div><div><br></div><div>Thank you for your interest in our Company.&nbsp; We would like to get to know you</div>',
                            "email_subject": "Test invitation email"
                        },auth).then(resp=>{
                            allresult.push(resp);
                        })
                    }
                    console.log("7",allresult);
                    if (this.all_candidate_id.length === allresult.length) {
                        console.log("jhjhggyugyggygy");
                        
                        this.snackbar = true;
                        this.showMessage = 'Invited Successfully.'
                        // this.allStudentData();
                        this.dataLoading = false;
                        this.$router.push({name : 'invite_talent', params: { id: id }});
                    } else {
                        this.dataLoading = false;
                        this.snackbar = true;
                        this.showMessage = 'Something wrong! Please try again.'
                    }
                }
            }
        
      },
 
    }
})